import { BASE_URL } from '../utils/constants';
import { AXIOS_INSTANCE } from '.';

export const getWhatsappLinksAPI = async () => {
  try {
    const { data } = await AXIOS_INSTANCE.get(
      `${BASE_URL}/admin/whatsapp-link`
    );
    return data;
  } catch (error) {
    return error;
  }
};

export const getWhatsappLinkByIdAPI = async (id) => {
  try {
    const { data } = await AXIOS_INSTANCE.get(
      `${BASE_URL}/admin/whatsapp-link/${id}`
    );
    return data;
  } catch (error) {
    return error;
  }
};

export const createWhatsappLinkAPI = async (payload) => {
  try {
    const { data } = await AXIOS_INSTANCE.post(
      `${BASE_URL}/admin/whatsapp-link`,
      payload
    );
    return data;
  } catch (error) {
    return error;
  }
};

export const updateWhatsappLinkAPI = async (id, payload) => {
  try {
    const { data } = await AXIOS_INSTANCE.put(
      `${BASE_URL}/admin/whatsapp-link/${id}`,
      payload
    );
    return data;
  } catch (error) {
    return error;
  }
};

export const deleteWhatsappLinkAPI = async (id) => {
  try {
    const { data } = await AXIOS_INSTANCE.delete(
      `${BASE_URL}/admin/whatsapp-link/${id}`
    );
    return data;
  } catch (error) {
    return error;
  }
};
